import {
  Card,
  CardContent,
  Chip,
  LinearProgress,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import React from "react";
import { Assessment, Star, Timer } from "@mui/icons-material";

// TODO: mocked achievements - currently not used

const AchievementCard = ({
  AchievementIcon,
  title,
  subtitle,
  value,
  target,
  highlight = false,
}) => {
  const theme = useTheme();

  const color = highlight
    ? theme.palette.success.main
    : theme.palette.info.main;
  return (
    <Card
      variant={"background"}
      sx={{
        mt: 1,
        backgroundColor: highlight ? "success.light" : "background.default",
      }}
    >
      <CardContent>
        <Stack
          direction={"row"}
          alignItems={"flex-start"}
          sx={{ width: "100%" }}
        >
          <AchievementIcon fontSize="large" sx={{ color: color }} />
          <Stack direction={"column"} sx={{ width: "100%", ml: 2 }}>
            <Stack direction={"row"} spacing={2} alignItems={"center"}>
              <Typography variant={"h5"} fontWeight="bold">
                {title}
              </Typography>
              <Chip
                label={`${value}/${target}`}
                sx={{
                  backgroundColor: color,
                  "& .MuiChip-label": {
                    color: "common.white",
                  },
                }}
              />
            </Stack>
            <Typography variant={"subtitle1"}>{subtitle}</Typography>
            <LinearProgress
              variant="determinate"
              value={(value / target) * 100}
              sx={{
                "& .MuiLinearProgress-bar1": {
                  backgroundColor: color,
                },
                mt: 1,
              }}
            />
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
};

export const Achievements = () => {
  return (
    <Card variant={"shadow"}>
      {/* TODO: This is all currently mocked! */}
      <CardContent>
        <Typography variant="h3" sx={{ mt: 1, mb: 2 }}>
          Achievements
        </Typography>
        <AchievementCard
          highlight
          AchievementIcon={Star}
          title={"Essay Marking Pro"}
          subtitle={"Maintain a 3 day streak"}
          value={3}
          target={3}
        />
        <AchievementCard
          AchievementIcon={Assessment}
          title={"Performance Tracker"}
          subtitle={"Achieve 1500 more points"}
          value={2000}
          target={3500}
        />
        <AchievementCard
          AchievementIcon={Timer}
          title={"Time Saved"}
          subtitle={"Achieve 25 hours to unlock your reward"}
          value={8}
          target={25}
        />
      </CardContent>
    </Card>
  );
};
